module.exports = __webpack_public_path__ + "img/sergeant-student-img.b1862038.png";